<template>
  <div id="xzt">
    <div class="header">
      <div class="header-left">
        <span> 当前用户:{{ this.user.username }}</span>
        <span v-if="lookUser"> 查看用户:{{ this.lookUser.username }}</span>

        <span> 总注数:{{ totalPrice }} </span>
        <span> 抄底平均值(倍数:{{ average }}): {{ averagePrice }} </span>
        <!-- <span> 最大值:{{ maxPrice }} </span> -->
        <!-- <span> 最小值:{{ minPrice }} </span> -->
        <!-- <span> 总下注次数:{{ totalCount }} </span> -->
      </div>
      <div class="header-right">
        <el-button type="danger" @click="onClearAll" v-show="showAdmin">总清除</el-button>
        <el-button type="danger" @click="onClear">清除</el-button>
        <el-button type="primary" @click="onAll" v-show="showAdmin">总结算</el-button>
        <el-button type="primary" @click="onSettlement">结算</el-button>
        <el-button type="primary" @click="onStatics">统计</el-button>
        <el-button type="primary" @click="addUser" v-show="showAdmin">帐号列表</el-button>
      </div>
    </div>
    <div class="content clearfix">
      <div class="content-left">
        <div class="nums">
          <div class="nums-title">特码A</div>
          <div class="nums-rows clearfix">
            <div class="num-row" v-for="(nnitem, nindex) in nums">
              <template v-for="(nitem, index) in nnitem">
                <div :class="nitem.selected == true ? 'nums-item active' : 'nums-item'
                  " @click="onSelectItem(index, nindex)">
                  <p :class="`${nitem.color}`">{{ nitem.title }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="sxs clearfix">
          <template v-for="(sitem, index) in sx">
            <div :class="sitem.selected == true ? 'sxs-item active' : 'sxs-item'" @click="onSXitem(index)">
              {{ sitem.name }}
            </div>
          </template>
        </div>
        <div class="others clearfix">
          <template v-for="(oitem, oindex) in other">
            <div :class="ooindex == oindex ? 'other active' : `other ${oitem.color}`" @click="onOther(oindex)">{{
              oitem.value }}
            </div>
          </template>
        </div>
        <div class="tools">
          <span>金额:</span>
          <el-input placeholder="" v-model="sx_money"></el-input>
          <el-button type="primary" @click="onBuysx">确定</el-button>
          <el-button type="warning" @click="onClearsx">清空</el-button>
        </div>
        <div class="nums-bottom">
          <template v-for="(iitem, iindex) in moneys">
            <div :class="nindex == iindex ? 'num active' : 'num'" @click="onNum(iindex, iitem)">{{ iitem }}</div>
          </template>
        </div>
      </div>
      <div class="sx-content">
        <div class="title">平肖</div>
        <template v-for="(item, index) in sx">
          <div class="sx-item" :key="index">
            <s-item :item="item" :index="index" @buy="onItemBuy" />
          </div>
        </template>
      </div>
      <div class="ws-content">
        <div class="title">尾数</div>
        <template v-for="(item, index) in ws">
          <div class="ws-item" :key="index">
            <s-item :item="item" :index="index" @buy="onItemBuyTwo" />
          </div>
        </template>
      </div>
      <div class="sx-content-new">
        <div class="title">生肖</div>
        <template v-for="(item, index) in sx">
          <div class="item" :key="index" v-if="item.values">
            <div class="title">{{ item.name }}</div>
            <div class="content"><template v-for="iitem in item.values">
                <label>{{ iitem }}</label>
              </template>
            </div>
          </div>
        </template>
      </div>
      <!-- <template v-for="(item, index) in nums">
        <div class="grid-content">
          <template v-for="(iitem, iindex) in item">
            <div :class="`item ${iitem.color}`">
              <item-number
                :item="iitem"
                :index="index"
                :iindex="iindex"
                @buy="onBuy"
              />
            </div>
          </template>
        </div>
      </template> -->
    </div>
    <div class="footer"></div>
    <x-list ref="x-list"></x-list>
    <s-list ref="s-list"></s-list>
    <add-user ref="addUser"></add-user>
    <user-list ref="userList" @sucess="onSelectUser" @look="onLookUser"></user-list>
  </div>
</template>
<script>
import { getNumbers, getMoney, getTotals } from "./num.js";
import { getLocalUser } from "../../config/cache.js";
import ItemNumber from "./item.vue";
import SItem from "./sxitem.vue";
import xList from "./list.vue";
import sList from "./slist.vue";
import addUser from "./adduser.vue"
import userList from "./userlist.vue"
const arr = [1, 0, 'red', 'blue', 'green', 2, 3, 4, 5];
export default {
  components: { ItemNumber, xList, addUser, userList, sList, SItem },
  data() {
    return {
      nums: [],
      nindex: -1,
      selectedSX: -1,
      totalPrice: 0,
      totalCount: 0,
      maxPrice: 0,
      minPrice: 0,
      averagePrice: 0, //平均
      average: 45, //42倍 倍数
      buyPrice: 0, //可买
      sx_money: "",
      showAdmin: false,
      currentYear: 2021,
      user: null,
      lookUser: null,
      moneys: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 1000],
      other: [
        {
          value: "单",
          color: 'black'
        },
        {
          value: "双",
          color: 'black'
        },
        {
          value: "红 波",
          color: 'red'
        },
        {
          value: "蓝 波",
          color: 'blue'
        },
        {
          value: "绿 波",
          color: 'green'
        },
        {
          value: "大",
          color: 'black'
        },
        {
          value: "小",
          color: 'black'
        },
        {
          value: "家 禽",
          color: 'black'
        },
        {
          value: "野 兽",
          color: 'black'
        },
      ],
      ooindex: -1,
      sx: [
        
      ],
      //第一个改的地方
      sxvalue: [
        [7, 19, 31, 43],
        [6, 18, 30, 42],
        [5, 17, 29, 41],
        [4, 16, 28, 40],
        [3, 15, 27, 39],
        [2, 14, 26, 38],
        [1, 13, 25, 37, 49],
        [12, 24, 36, 48],
        [11, 23, 35, 47],
        [10, 22, 34, 46],
        [9, 21, 33, 45],
        [8, 20, 32, 44],
        
      ],
      //第二个改的地方
      sxtt: [7, 6, 5, 4, 3, 2, 1, 12, 11, 10, 9, 8,],
      ws: [
        { name: "0尾", value: 0 },
        { name: "1尾", value: 0 },
        { name: "2尾", value: 0 },
        { name: "3尾", value: 0 },
        { name: "4尾", value: 0 },
        { name: "5尾", value: 0 },
        { name: "6尾", value: 0 },
        { name: "7尾", value: 0 },
        { name: "8尾", value: 0 },
        { name: "9尾", value: 0 }]
    };
  },
  created() {

    this.user = getLocalUser();

    console.log("userinfo:", this.user);
    // var query = this.$route.query
    if (this.user.username != undefined) {
      this.showAdmin = (this.user.username == "admin" ? true : false);
    }
    this.init();
  },
  methods: {
    onSelectUser(value) {
      this.$refs.addUser.show(value)
    },
    onLookUser(value) {
      this.lookUser = value;
      this.init();
    },
    addUser() {
      // this.$refs["add-user"].show();
      this.$refs["userList"].show();
    },
    init() {
      this.nums = [];
      this.totalPrice = 0;
      this.averagePrice = 0;
      this.ws = [
        { name: "0尾", value: 0 },
        { name: "1尾", value: 0 },
        { name: "2尾", value: 0 },
        { name: "3尾", value: 0 },
        { name: "4尾", value: 0 },
        { name: "5尾", value: 0 },
        { name: "6尾", value: 0 },
        { name: "7尾", value: 0 },
        { name: "8尾", value: 0 },
        { name: "9尾", value: 0 }];
      this.sx = [
        {
          name: "鼠",
          index: 5,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "牛",
          index: 4,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "虎",
          index: 3,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "兔",
          index: 2,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "龙",
          index: 1,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "蛇",
          index: 12,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "马",
          index: 11,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "羊",
          index: 10,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "猴",
          index: 9,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "鸡",
          index: 8,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "狗",
          index: 7,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "猪",
          index: 6,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },];

      for (let i = 0; i < this.sx.length; i++) {
        this.sx[i].values = this.sxvalue[i];
        this.sx[i].index = this.sxtt[i];
      }


      this.$http.get("/admin/xzt/lunar").then(res => {
        if (res.data) {
          this.currentYear = parseInt(res.data);
          this.setSx();
        }
      });
      let lookid = "";
      if (this.lookUser) {
        lookid = this.lookUser.id;
      }
      this.$http.get("/admin/xzt/index", { look: lookid }).then(res => {
        let data = res.data;
        let maps = [];
        data.forEach(item => {
          maps[item.num] = item.value;
          this.totalPrice = this.totalPrice + parseInt(item.value);
        })

        this.averagePrice = parseInt(this.totalPrice / this.average);
        this.nums = getNumbers(maps);
        this.$http.get("/admin/xzt/statics", { look: lookid }).then(res => {
          console.log("statics:", res);
          let data = res.data;
          data.forEach(item => {
            var type = parseInt(item.type);
            if (type < 13) {
              this.sx[type - 1].value = item.value;
            } else if (type >= 13 && type < 24) {
              this.ws[type - 13].value = item.value;
            }
          })
        })
      })
    },
    setSx() {
      var space = this.currentYear % 12 - 3;
      for (var i = 0; i < this.sx.length; i++) {
        var val = this.sx[i];
        var index = 12 - ((i + space) % 12);

      }
    },

    onClearAll(){
let self = this;
      this.$confirm('是否确认清除所有信息？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '清除',
        cancelButtonText: '放弃'
      })
        .then(() => {
          self.$http.get("/admin/xzt/clearall").then(res => {
            self.$message.success("清除成功");
            self.totalPrice = 0;
            self.averagePrice = 0;
            self.init();
          });
        })
        .catch(action => {

        });
    },
    onClear() {
      let self = this;
      this.$confirm('是否确认清除此次所有信息？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '清除',
        cancelButtonText: '放弃'
      })
        .then(() => {
          self.$http.get("/admin/xzt/clear").then(res => {
            self.$message.success("清除成功");
            self.totalPrice = 0;
            self.averagePrice = 0;
            self.init();
          });
        })
        .catch(action => {

        });

    },
    onNum(index, value) {
      if (this.nindex == index) {
        this.nindex = -1;
        this.sx_money = "";
        return;
      }
      this.nindex = index;
      this.sx_money = value + "";
    },
    onOther(index) {
      if (this.ooindex == index) {
        this.ooindex = -1;
        if (index == 7) {
          for (var s = 0; s < this.sx.length; s++) {
            let sitem = this.sx[s];
            if (sitem.isjq == true) {
              this.onSXitem(s);
            }
          }
        }
        if (index == 8) {
          for (var s = 0; s < this.sx.length; s++) {
            let sitem = this.sx[s];
            if (sitem.isjq == false) {
              this.onSXitem(s);
            }
          }
        }
      } else {
        this.ooindex = index;
      }
      if (index < 7) {
        for (var s = 0; s < this.sx.length; s++) {
          let sitem = this.sx[s];
          this.onSXitemOther(s, false);
        }
      }

      var a = arr[index];
      for (var i = 0; i < this.nums.length; i++) {
        var nitems = this.nums[i];
        for (var j = 0; j < nitems.length; j++) {
          var item = this.nums[i][j];
          if (this.ooindex == -1) {
            item.selected = false;
          } else {

            if (index < 2) {
              if (item.title % 2 == a) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else if (index > 1 && index < 5) {
              if (item.color == a) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else if (index == 6) { //小
              if (parseInt(item.title) < 25) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else if (index == 5) {//大
              if (parseInt(item.title) > 24) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else if (index == 7) {//家禽
              for (var s = 0; s < this.sx.length; s++) {
                let sitem = this.sx[s];
                if (sitem.isjq == true) {
                  this.onSXitemOther(s, true);
                } else {
                  this.onSXitemOther(s, false);
                }
              }
            } else if (index == 8) {//野兽
              for (var s = 0; s < this.sx.length; s++) {
                let sitem = this.sx[s];
                if (sitem.isjq == false) {
                  this.onSXitemOther(s, true);
                } else {
                  this.onSXitemOther(s, false);
                }
              }
            }
          }

        }
      }
    },
    onSelectItem(index, nindex) {
      let selected = this.nums[nindex][index].selected;
      this.nums[nindex][index].selected = !selected;
    },
    onSXitemOther(value, selected) {
      let item = this.sx[value];
      this.sx[value].selected = selected;
      let sx = item.index;
      let isMax = sx > 1 ? 0 : 1;
      for (var i = 0; i < 4 + isMax; i++) {
        let num = sx + i * 12;
        let index = Math.ceil(num / 10) - 1;
        let iindex = num % 10 - 1;
        if (iindex < 0) {
          iindex = 9;
        }
        this.nums[index][iindex].selected = this.sx[value].selected;
      }
    },
    onSXitem(value) {
      //this.selectedSX = index;
      let item = this.sx[value];
      this.sx[value].selected = !item.selected;
      let sx = item.index;
      let isMax = sx > 1 ? 0 : 1;
      for (var i = 0; i < 4 + isMax; i++) {
        let num = sx + i * 12;
        let index = Math.ceil(num / 10) - 1;
        let iindex = num % 10 - 1;
        if (iindex < 0) {
          iindex = 9;
        }
        console.log("index:", index, "iindex:", iindex,"sx:",sx);
        this.nums[index][iindex].selected = this.sx[value].selected;
      }
    },
    onStatics() {
      this.$refs["s-list"].show(this.sx, this.ws);
    },
    onAll() {
      this.$router.push({
        path: '/all',
        query: {
          user: this.lookUser
        }
      })
    },
    onSettlement() {
      let settlement = getMoney(
        this.nums,
        this.totalPrice,
        this.averagePrice,
        this.average
      );
      this.buyPrice = settlement.buy_price;
      console.log("averagePrice:", this.averagePrice, "total:", this.totalPrice, "average:", this.average);
      this.$refs["x-list"].show(settlement, this.totalPrice, this.averagePrice, this.user);
    },
    onClearsx() {
      for (var i = 0; i < this.nums.length; i++) {
        let items = this.nums[i];
        for (var j = 0; j < items.length; j++) {
          let item = items[j];
          item.selected = false;
        }
      }

      for (var ii = 0; ii < this.sx.length; ii++) {
        let item = this.sx[ii];
        item.selected = false;
      }
      this.sx_money = "";
    },
    onBuysx() {

      if (this.sx_money == "") return;
      for (var i = 0; i < this.nums.length; i++) {
        let items = this.nums[i];
        for (var j = 0; j < items.length; j++) {
          let item = items[j];
          if (item.selected) {
            this.onBuy(this.sx_money, i, j);
          }
        }
      }
      this.onClearsx();
    },
    onBuysx_old() {
      if (this.selectedSX > -1) {
        // console.log("money:", this.sx_money,'index:',this.selectedSX);
        let isMax = (this.selectedSX) > 0 ? 0 : 1;
        let sx = this.selectedSX + 1;
        console.log("index:", sx);
        for (var i = 0; i < 4 + isMax; i++) {
          let num = sx + i * 12;
          let index = Math.ceil(num / 10) - 1;
          let iindex = num % 10 - 1;
          this.onBuy(this.sx_money, index, iindex);
          console.log("num:", num, "index:", index, "iindex:", iindex);
        }

      }
    },
    onItemBuy(val, ii) {
      var index = parseInt(ii) + 1;
      console.log("val:", val,"index:",index);

      
      this.$http.post("/admin/xzt/addstatics", { type: parseInt(index), value: parseInt(val) }).then(res => {
        console.log("res:", res);
        let vv = parseInt(this.sx[ii].value);
        this.sx[ii].value = vv + parseInt(val);
      });
    },
    onItemBuyTwo(val, ii) {
      var index = parseInt(ii) + 13;
      console.log("val:", val);
      this.$http.post("/admin/xzt/addstatics", { type: parseInt(index), value: parseInt(val) }).then(res => {
        console.log("res:", res);
        let vv = parseInt(this.ws[ii].value);
        this.ws[ii].value = vv + parseInt(val);
      });
    },
    onBuy(val, index, iindex) {

      let value = parseInt(val);

      let item = this.nums[index][iindex];
      item.total = parseInt(item.total) + value;
      this.totalCount += 1;
      this.nums[index][iindex] = item;

      console.log("num:", item.title, "value:", item.total);

      this.$http.post("/admin/xzt/edit", { num: parseInt(item.title), value: parseInt(item.total) }).then(res => {

        console.log("res:", res);
      });

      this.totalPrice = this.totalPrice + value;

      //   if(this.totalPrice>5000)//开始计算平均数
      //   {
      //       this.averagePrice = parseInt(this.totalPrice / 42.75);
      //   }

      this.averagePrice = parseInt(this.totalPrice / this.average);

      if (value > this.maxPrice) {
        this.maxPrice = value;
      }
      if (this.minPrice == 0) {
        this.minPrice = value;
      } else if (value < this.minPrice) {
        this.minPrice = value;
      }
    },
  },
};
</script>
<style lang="less" scoped>
#xzt {
  font-size: 12px;
  color: black;

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }

  .header {
    height: 40px;
    width: 100%;
    background-image: linear-gradient(to right, #0f6ad7, #00ced4);
    padding: 0px 30px;
    box-sizing: border-box;
    color: white;
    font-size: 20px;
    text-align: left;
    display: flex;
    line-height: 40px;

    .header-left {
      flex: 1;

      span {
        margin-right: 30px;
      }
    }

    .header-right {
      flex: none;

      .el-button {
        padding: 5px 30px;
        font-size: 18px;
      }
    }
  }

  .footer {
    height: 50px;
  }

  .content {
    max-width: 1200px;
    margin: 0 auto;

    .content-left {
      width: 30%;
      margin-top: 5px;
      float: left;
      height: 600px;

      .sxs {
        margin-top: 10px;

        .sxs-item {
          width: 16.6%;
          float: left;
          cursor: pointer;
          line-height: 30px;
          // border:1px solid #ddd;
          box-sizing: border-box;
          font-size: 15px;
          font-weight: bold;

          &.active {
            background: #ddd;
          }
        }
      }

      .nums-bottom {
        width: 100%;
        margin-top: 10px;

        .num {
          width: 19%;
          cursor: pointer;
          float: left;
          font-size: 16px;
          font-weight: bold;
          height: 40px;
          line-height: 40px;
          border: 1px solid #ddd;
          color: black;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;

          &.active {
            background: red;
            color: white;
          }
        }
      }

      .others {
        margin-top: 10px;

        .other {
          float: left;
          width: 20%;
          box-sizing: border-box;
          height: 40px;
          border: 1px solid #ddd;
          line-height: 40px;
          font-size: 14px;
          color: red;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;

          &.active {
            background: red;
            color: white;
          }

          &.black {
            color: black;
          }

          &.red {
            color: red;
          }

          &.blue {
            color: rgb(118, 118, 242);
          }

          &.green {
            color: rgb(64, 209, 64);
          }
        }
      }

      .tools {
        display: flex;
        flex-direction: row;
        margin-top: 10px;

        span {
          width: 50px;
          line-height: 40px;
        }

        .el-button {
          padding: 10px 20px;
          margin-left: 5px;
          box-sizing: border-box;
        }

        .el-input {
          width: 100px;
        }
      }

      .nums {
        .nums-title {
          background: red;
          line-height: 30px;
          font-size: 20px;
        }

        .nums-rows {
          .num-row {
            width: 20%;
            float: left;

            .nums-item {
              border: 1px solid #ddd;
              box-sizing: border-box;
              height: 40px;
              line-height: 40px;
              font-size: 15px;
              font-weight: bold;

              p {
                &.red {
                  color: red;
                }

                &.blue {
                  color: rgb(118, 118, 242);
                }

                &.green {
                  color: rgb(64, 209, 64);
                }
              }

              &.active {
                background: yellow;
              }
            }
          }
        }
      }
    }

    .sx-content-new {
      width: 20%;
      float: left;
      margin-left: 5px;
      margin-top: 5px;

      .title {
        line-height: 30px;
        background: green;
        font-size: 20px;
        color: white;
      }

      .item {
        width: 100%;
        background: green;
        margin-top: 5px;
        text-align: left;
        padding: 5px;
        line-height: 47px;
        max-height: 57px;
        font-size: 26px;
        color: white;
        box-sizing: border-box;
        display: flex;
        padding-left: 10px;

        .title {
          width: 50px;
          font-size: 30px;
          text-align: center;
          line-height: 44px;
          font-weight: bold;
        }

        .content {
          flex: 1;
        }

        label {
          margin-left: 10px;
          line-height: 47px;

        }
      }
    }

    .sx-content {
      width: 20%;
      float: left;
      margin-left: 5px;
      margin-top: 5px;

      .title {
        line-height: 30px;
        background: #0f6ad7;
        font-size: 20px;
        color: white;
      }

      .sx-item {
        width: 100%;
        background: #0f6ad7;
        margin-top: 5px;
        text-align: left;
        padding: 5px;
        box-sizing: border-box;
      }
    }

    .ws-content {
      width: 20%;
      height: 500px;
      margin-left: 5px;
      margin-top: 5px;
      float: left;

      .title {
        color: white;
        line-height: 30px;
        background: olive;
        font-size: 20px;
      }

      .ws-item {
        width: 100%;
        background: olive;
        margin-top: 5px;
        text-align: left;
        padding: 5px;
        box-sizing: border-box;
      }
    }

    .grid-content {
      width: 14%;
      float: left;

      .item {
        width: calc(100% - 20px);
        background: #0f6ad7;
        margin-top: 5px;
        margin-right: 10px;
        margin-left: 10px;
        text-align: left;
        padding: 5px;
        box-sizing: border-box;

        &.red {
          background: red;
        }

        &.blue {
          background: rgb(118, 118, 242);
        }

        &.green {
          background: rgb(64, 209, 64);
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .clearfix:after {
      visibility: hidden;
      display: block;
      font-size: 0;
      height: auto;
    }
    .header{
      display: block;
      height: auto;
    }
    .content {
      width: 100%;

      .content-left {
        width: 100%;
        height: auto;
        .sxs {
          width: 100%;
          
        }
        .others {
          width: 100%;
        }
      }
      .sx-content {
        width: 50%;
        margin: 0;
      }
      .ws-content{
        width: 50%;
        margin: 0;
      }
      .sx-content-new {
        width: 100%;
        margin:0;
      }
    }

  }
}
</style>